import React, { FC, useState, useEffect, useContext } from 'react'
import platform from 'platform'
import { notify } from 'react-notify-toast'
import moment from 'moment'
import { isMobile } from 'react-device-detect'

import {
  getUserData,
  getTrainingDays,
  unSubscribeNewsletter,
  subscribeToNewsletter,
} from '../../../../Api/backendApi'

import GenericTextSpan from '../../../../GenericComponents/GenericTextSpan'
import GenericRow from '../../../../GenericComponents/GenericRow'
import GenericButton from '../../../../GenericComponents/GenericButton'
import GenericCloseButton from '../../../../GenericComponents/GenericCloseButton'

import {
  SingleSettingModalBox,
  UserDataContainer,
} from '../../style/UserProfileStyle'

interface AppVersionInterface {
  closeModal: Function
}

const AppVersion: FC<AppVersionInterface> = ({ closeModal }) => {
  return (
    <SingleSettingModalBox>
      <GenericCloseButton onClick={closeModal} />
      <GenericRow margin={'0% 0 3% 0'}>
        <GenericTextSpan fSize={'2rem'} fWeight={'bold'}>
          Wersja aplikacji
        </GenericTextSpan>
      </GenericRow>
      <GenericRow>
        <GenericTextSpan fSize={isMobile ? '1.3rem' : '1rem'} width={'60%'}>
          2.0
        </GenericTextSpan>
      </GenericRow>
    </SingleSettingModalBox>
  )
}

export default AppVersion
